import ReduxFormDatePicker from 'components/shared/Forms/ReduxFormDatePicker'
import { I18n } from 'lib/i18n'
import React from 'react'
import { Field } from 'redux-form'
import { Grid } from 'semantic-ui-react'

const i18nkey = 'admin.discounts.details.'

export default () => (
  <Grid.Row>
    <Grid.Column width={6}>
      <Field
        label={I18n.t(i18nkey + 'valid_from')}
        component={ReduxFormDatePicker}
        name="valid_from"
        inline
      />
    </Grid.Column>
    <Grid.Column width={6}>
      <Field
        label={I18n.t(i18nkey + 'valid_until')}
        component={ReduxFormDatePicker}
        endOfDay
        name="valid_until"
        inline
      />
    </Grid.Column>
  </Grid.Row>
)



// WEBPACK FOOTER //
// ./src/components/admin/Discounts/DiscountDates.jsx